import type { TFunction } from "./UploadOptions.types";
import FileUpload from "../ui/FileUpload";

interface UploadOptionsProps {
  value: string;
  onChange: (v: string, dataUrl?: string, file?: File) => void;
  showScanner: boolean;
  showScannerApps: boolean;
  t: TFunction;
  accept?: string;
  /** Trash control: parent confirms then clears (session delete). */
  onRequestClear?: () => void;
}

export default function UploadOptions({
  value,
  onChange,
  /** Retained for API compat; scanner UI intentionally not rendered - see comment block below. */
  showScanner: _showScanner,
  showScannerApps: _showScannerApps,
  t,
  accept = "application/pdf,image/jpeg,image/png",
  onRequestClear,
}: UploadOptionsProps) {
  return (
    <div className="flex flex-col gap-3">
      {/*
        Scanner entry points disabled - we do not ship an in-portal scanner. Multi-page docs should be
        a single PDF; page-by-photo flows caused confusion.

        Former Option 1 (showScanner - “Open scanner” hero + capture input):

      {showScanner && (
        <div className="rounded-2xl border border-emerald-200 bg-emerald-50/40 p-4">...</div>
      )}

        Former Option 2 (showScannerApps - Adobe Scan / copy shop hints):

      {showScannerApps && (
        <div className="rounded-2xl border border-slate-200 bg-white p-4">...</div>
      )}
      */}

      {/* Upload file + camera picker (same component as intake elsewhere) */}
      <div className="rounded-2xl border border-slate-200 bg-white p-4">
        <div className="flex items-start gap-3 mb-3">
          <div className="w-9 h-9 rounded-xl bg-slate-100 flex items-center justify-center shrink-0">
            <i className="ri-file-upload-line text-slate-600 text-base" />
          </div>
          <div>
            <p className="text-[14px] font-semibold text-slate-800">{t("upload.fileTitle")}</p>
            <p className="text-[12px] text-slate-500 mt-0.5">{t("upload.fileSubtitle")}</p>
          </div>
        </div>
        <FileUpload
          value={value}
          onChange={onChange}
          uploadBtnLabel={t("section7.uploadBtn")}
          cameraBtnLabel={t("section7.cameraBtn")}
          uploadedLabel={t("section7.uploadedLabel")}
          changeBtnLabel={t("section7.changeFile")}
          optionalLabel=""
          accept={accept}
          uploadedClearAction="trashIcon"
          removeAriaLabel={t("docUpload.removeDoc")}
          onRequestClear={onRequestClear}
        />
      </div>
    </div>
  );
}
